module.exports = __webpack_public_path__ + "static/media/h1.b4c5328c.png";